<script lang="ts">
    import type {SutorHomePageData} from '../types';
    import SutorHomePageIconCard from '../components/SutorHomePageIconCard.svelte';

    export let homepageData: SutorHomePageData;
</script>

<ul class="sutor-homepage-info-cards">
    <li class="info-card-item">
        <SutorHomePageIconCard href="/#!/projects"
                               icon="check-circle"
                               label="Zakázky"
                               value="{homepageData.fondItemCounts[1]}"
                               cardBackground="#FFDCE0"
                               iconBackground="#FF5347"/>
    </li>

    <li class="info-card-item">
        <SutorHomePageIconCard href="/#!/record-grid/fond/77/view"
                               icon="check-circle"
                               label="Objednávky"
                               value="{homepageData.fondItemCounts[77]}"
                               cardBackground="#FFDCE0"
                               iconBackground="#FF5347"/>
    </li>

    <li class="info-card-item">
        <SutorHomePageIconCard href="/#!/record-grid/fond/107/view"
                               icon="check-circle"
                               label="Faktury s položkami"
                               value="{homepageData.fondItemCounts[107]}"
                               cardBackground="#FFDCE0"
                               iconBackground="#FF5347"/>
    </li>
</ul>

<ul class="sutor-homepage-info-cards">
    <li class="info-card-item">
        <SutorHomePageIconCard icon="edit"
                               href="/#!/reports"
                               label="Zadávání výkazů"
                               cardBackground="#FFE2CF"
                               iconBackground="#FF751F"/>
    </li>

    <li class="info-card-item">
        <SutorHomePageIconCard icon="assept-document"
                               href="/#!/reports/approving"
                               label="Schvalování výkazů"
                               cardBackground="#FFE2CF"
                               iconBackground="#FF751F"/>
    </li>
</ul>

<ul class="sutor-homepage-info-cards">
    <li class="info-card-item">
        <SutorHomePageIconCard icon="users"
                               href="/#!/employees"
                               label="Evidovaní pracovníci"
                               value="{homepageData.employeesCount}"
                               cardBackground="#DBE1FF"
                               iconBackground="#3951C8"/>
    </li>

    <li class="info-card-item">
        <SutorHomePageIconCard icon="grid-alt"
                               href="/#!/record-grid/fond/9/view"
                               label="Evidovaný majetek"
                               value="{homepageData.fondItemCounts[9]}"
                               cardBackground="#DBE1FF"
                               iconBackground="#3951C8"/>
    </li>

    <li class="info-card-item">
        <SutorHomePageIconCard icon="building"
                               href="/#!/departments"
                               label="Divize"
                               value="{homepageData.departmentsCount}"
                               cardBackground="#DBE1FF"
                               iconBackground="#3951C8"/>
    </li>
</ul>

<ul class="sutor-homepage-info-cards">
    <li class="info-card-item">
        <SutorHomePageIconCard icon="tools"
                               href="/#!/record-grid/fond/70/view"
                               label="Profese"
                               value="{homepageData.fondItemCounts[70]}"
                               cardBackground="#ECDCFF"
                               iconBackground="#9747FF"/>
    </li>

    <li class="info-card-item">
        <SutorHomePageIconCard icon="cube"
                               href="/#!/record-grid/fond/71/view"
                               label="Skupiny majetku"
                               value="{homepageData.fondItemCounts[71]}"
                               cardBackground="#ECDCFF"
                               iconBackground="#9747FF"/>
    </li>
</ul>

<ul class="sutor-homepage-info-cards">
    <li class="info-card-item">
        <SutorHomePageIconCard iconDark
                               icon="grid-alt"
                               href="/#!/record-grid/fond/106/view"
                               label="Katalogové činnosti"
                               value="{homepageData.fondItemCounts[106]}"
                               cardBackground="#CBF6F0"
                               iconBackground="#0DE5C1"/>
    </li>

    <li class="info-card-item">
        <SutorHomePageIconCard iconDark
                               icon="grid-alt"
                               href="/#!/record-grid/fond/12/view"
                               label="Ceníky"
                               value="{homepageData.fondItemCounts[12]}"
                               cardBackground="#CBF6F0"
                               iconBackground="#0DE5C1"/>
    </li>

    <li class="info-card-item">
        <SutorHomePageIconCard iconDark
                               icon="grid-alt"
                               href="/#!/record-grid/fond/13/view"
                               label="Smlouvy"
                               value="{homepageData.fondItemCounts[13]}"
                               cardBackground="#CBF6F0"
                               iconBackground="#0DE5C1"/>
    </li>
</ul>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .sutor-homepage-info-cards {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
        gap: @spacing-xl;
        width: 100%;

        .info-card-item {
            width: 100%;
            height: 100%;
        }
    }
</style>